$(document).ready(function() {
  if (document.querySelector('#cart_form') != null) { submitFormHandler() }
  enabledSubmitButton()
})

$(document).ready(function() {
  const cartProcess = document.querySelector(".cart-order-process");
  const cartEdit = document.querySelector(".cart-order-edit");
  let isEditShow = false;

  if (document.querySelector("#cart-edit-button") != null) {
    document
      .querySelector("#cart-edit-button")
      .addEventListener("click", () => {
        isEditShow = !isEditShow;
        if (isEditShow) {
          cartProcess.classList.add("d-none");
          cartEdit.classList.remove("d-none");
        } else {
          cartProcess.classList.remove("d-none");
          cartEdit.classList.add("d-none");
        }
      });
  }
  let qty = document.getElementById("cart-item-cart-voucher-quantity");
  let hiddenQty = document.getElementById("form-cart-input-liquid");
  let dest = document.getElementById("destination");
  let btnCart = document.getElementById("add_to_cart");
  let btnCheckout = document.getElementById("checkout");

  function submitForm() {
    // document.forms[0].submit()
    HTMLFormElement.prototype.submit.call(document.forms[0]);
  }

  function replaceQty() {
    hiddenQty.value = qty.value;
  }

  function toCart() {
    dest.value = "cart";
    submitForm();
  }

  function toCheckout() {
    dest.value = "checkout";
    submitForm();
  }

  function submitForm() {
    document.forms[0].submit();
  }

  if (qty != null) {
    qty.onchange = replaceQty;
  };
  if (btnCart != null) {
    btnCart.onclick = submitForm;
  };
  if (btnCheckout != null) {
    btnCheckout.onclick = toCheckout;
  }
});

const submitFormHandler = () => {
  document.querySelector('#cart_form').addEventListener('submit', (e) => {
    const allData         = getAllCart();
    const anyItemsChecked = allData.filter(r => r.enabled).length > 0;

    if (!anyItemsChecked) {
      e.preventDefault();
      setTimeout(function () {
        enabledSubmitButton();
      }, 30)
    }
  })
}

const getAllCart = () => {
  return Array.from(document.querySelectorAll(".cart-item")).map((r) => {
    const hasChecked = r.querySelector(".form-check-input-cart").checked;
    const quantity = r.querySelector(".form-input-cart-quantity").value;
    const value = parseFloat(r.getAttribute("data-price") || 0).toFixed(2);
    const discount = parseFloat(r.getAttribute("data-discount") || 0).toFixed(2);
    return hasChecked
      ? {
          value: parseFloat(value) * parseInt(quantity),
          discount: parseFloat(discount),
          enabled: true,
        }
      : {
          value: 0,
          discount: 0,
          enabled: false,
        };
  });
};

const calculateTotalCart = () => {
  const allData = getAllCart();
  const totalVal = allData.reduce((a, b) => a + b.value, 0);
  const totalDiscount = allData.reduce((a, b) => a + b.discount, 0);
  const sumVal = totalVal - totalDiscount;

  document.querySelectorAll(".original-price").forEach((el) => {
    el.innerText = formatMoney(totalVal);
  });
  const hasAllChecked = allData.filter(r => r.enabled).length === allData.length;

  document.querySelectorAll(".final-price").forEach((el) => {
    el.innerText = formatMoney(sumVal);
  });

  document.querySelectorAll(".discount-price").forEach((el) => {
    el.innerText = formatMoney(totalDiscount);
  });

  document.querySelectorAll(".parent-cart-calculation").forEach((el) => {
    if (sumVal <= 0) {
      el.classList.add("d-none");
    } else {
      el.classList.remove("d-none");
    }
  });

  if (document.querySelector("#check-all") != null) {
    if (hasAllChecked) {
      document.querySelector("#check-all").checked = true;
    } else {
      document.querySelector("#check-all").checked = false;
    }
  }
};

const enabledSubmitButton = () => {
  const submitButton = document.querySelector('#cart_form input[type="submit"]');
  if (submitButton == null) { return false };

  const allData         = getAllCart();
  const anyItemsChecked = allData.filter(r => r.enabled).length > 0;

  if (anyItemsChecked) {
    submitButton.removeAttribute('disabled')
  } else {
    submitButton.setAttribute('disabled', 'disabled')
  };
  submitButton.value = submitButton.dataset.disabledWith
}

$(document).ready(function() {
  calculateTotalCart();

  document.querySelectorAll(".cart-item").forEach((el) => {
    const checkbox = el.querySelector(".form-check-input-cart");
    const quantity = el.querySelector(".form-input-cart-quantity");

    checkbox.addEventListener("change", calculateTotalCart);
    checkbox.addEventListener('change', enabledSubmitButton)
    quantity.addEventListener("change", calculateTotalCart);
    calculateTotalCart();
  });

  if (document.querySelector("#check-all") != null) {
    document.querySelector("#check-all").addEventListener("change", (e) => {
      const isChecked = e.target.checked;
      document.querySelectorAll(".form-check-input-cart").forEach((el) => {
        el.checked = isChecked;
        el.dispatchEvent(new Event("change"));
      });
    });
    $('#check-all').trigger('click');
  }
});

$(document).ready(function() {
  var deleteCartButtons = document.getElementsByClassName('delete-cart');
  var cardListSections = document.getElementsByClassName('card-list');
  var currentVisibleCard = null;

  Array.prototype.forEach.call(deleteCartButtons, function(button) {
    button.addEventListener('click', function() {
      var cardListSection = button.closest('.card-list');

      // Remove class from the previously visible card, if any
      if (currentVisibleCard && currentVisibleCard !== cardListSection) {
        currentVisibleCard.classList.remove('show-remove-section');
      }

      // Toggle class on the clicked card and update the current visible card
      cardListSection.classList.toggle('show-remove-section');
      currentVisibleCard = cardListSection.classList.contains('show-remove-section') ? cardListSection : null;
    });
  });

  Array.prototype.forEach.call(cardListSections, function(el) {
    el.addEventListener('swiped-left', function() {
      var cardListSection = el.closest('.card-list');

      // Remove class from the previously visible card, if any
      if (currentVisibleCard && currentVisibleCard !== cardListSection) {
        currentVisibleCard.classList.remove('show-remove-section');
      }

      // Toggle class on the swiped card and update the current visible card
      cardListSection.classList.toggle('show-remove-section');
      currentVisibleCard = cardListSection.classList.contains('show-remove-section') ? cardListSection : null;
    });

    el.addEventListener('swiped-right', function() {
      var cardListSection = el.closest('.card-list');

      // Remove class from the previously visible card, if any
      if (currentVisibleCard && currentVisibleCard !== cardListSection) {
        currentVisibleCard.classList.remove('show-remove-section');
      }

      // Toggle class on the swiped card and update the current visible card
      cardListSection.classList.toggle('show-remove-section');
      currentVisibleCard = cardListSection.classList.contains('show-remove-section') ? cardListSection : null;
    });
  });
});